// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"488":"b3541d27d1c2673c","540":"727973242bb33abd","561":"b3541d27d1c2673c","888":"33808aca7abe3d54"}[chunkId] + ".css";
};